module.exports = __webpack_public_path__ + "img/logo_female.40e569df.svg";